module.exports = __webpack_public_path__ + "static/media/pink.caa045a0.png";